export interface IconProps {
    size?: number;
    color?: string;
}
export const Lamp = ({size = 25, color= '#878686'}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1819 33C19.6631 33 19.2285 32.824 18.8781 32.472C18.5278 32.12 18.352 31.6849 18.3508 31.1666C18.3495 30.6484 18.5253 30.2133 18.8781 29.8613C19.2309 29.5093 19.6655 29.3333 20.1819 29.3333H31.1688C31.6877 29.3333 32.1229 29.5093 32.4745 29.8613C32.826 30.2133 33.0012 30.6484 33 31.1666C32.9988 31.6849 32.823 32.1206 32.4726 32.4738C32.1223 32.827 31.6877 33.0024 31.1688 33H20.1819ZM4.6629 11H11.0262V3.66666H7.86742L4.6629 11ZM25.6754 27.5C25.1566 27.5 24.722 27.324 24.3716 26.972C24.0212 26.62 23.8454 26.1849 23.8442 25.6666V9.16666C23.8442 8.64722 23.6684 8.21211 23.3169 7.86133C22.9653 7.51055 22.5307 7.33455 22.0131 7.33333H14.6885V12.8333C14.6885 13.3528 14.5127 13.7885 14.1611 14.1405C13.8095 14.4925 13.3749 14.6679 12.8573 14.6667H1.87039C1.19897 14.6667 0.680143 14.3917 0.313912 13.8417C-0.0523186 13.2917 -0.0980975 12.7111 0.176575 12.1L4.52556 2.2C4.83076 1.52778 5.28061 0.993055 5.87512 0.595833C6.46964 0.198611 7.13374 0 7.86742 0H11.0262C12.0333 0 12.8958 0.359333 13.6136 1.078C14.3314 1.79667 14.6897 2.65955 14.6885 3.66666H22.0131C23.539 3.66666 24.8361 4.20139 25.9043 5.27083C26.9724 6.34027 27.5065 7.63888 27.5065 9.16666V25.6666C27.5065 26.1861 27.3307 26.6218 26.9792 26.9738C26.6276 27.3258 26.193 27.5012 25.6754 27.5Z"
        fill={color}
      />
    </svg>
  );
};

export const getIcon = (iconName: string, props?: IconProps) :  JSX.Element => {
    switch (iconName) {
        case 'lamp':
        return <Lamp {...props}/>;
        default:
        return <Lamp {...props}/>;
    }
}